module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot_wrap"
  }, [_c('div', {
    staticClass: "table_container"
  }, [_c('h1', [_vm._v("It’s done!")]), _vm._v(" "), _c('p', {
    staticClass: "notice"
  }, [_vm._v("You have reset your password.")]), _vm._v(" "), _c('a', {
    staticClass: "sign_in_ag",
    on: {
      "click": _vm.next_reset
    }
  }, [_vm._v("Sign in again")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65884c7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/forgot_password/forgot_password_step4.vue
// module id = 854
// module chunks = 1